import { publishPermissionDenied } from '@/services/events/eventPublisher.service';

const DEBOUNCE_MS = 60_000;
const STORAGE_PREFIX = 'erp:notify:denied:';

/** Notificación interna ante permiso denegado (debounced, anti-spam). */
export function notifyPermissionDeniedDebounced(
  key: string,
  params: { permission: string; path: string },
): void {
  if (typeof sessionStorage === 'undefined') {
    void publishPermissionDenied(
      {
        permission: params.permission,
        path: params.path,
      },
      `permission_denied:${key}`,
    );
    return;
  }

  const storageKey = `${STORAGE_PREFIX}${key}`;
  const last = sessionStorage.getItem(storageKey);
  const now = Date.now();
  if (last && now - Number(last) < DEBOUNCE_MS) return;

  sessionStorage.setItem(storageKey, String(now));
  void publishPermissionDenied(
    {
      permission: params.permission,
      path: params.path,
    },
    `permission_denied:${key}`,
  );
}
